import React from 'react';
import {useHistory } from 'react-router-dom';
import GramaticaForm from './GramaticaFormComponent';
import { postGramaticaFuerte, postGramaticaDebil } from '../../routing/routes';

const gramaticaDefault = {
	nombre: '',
	arista: { operacion: '', scripts: [], condiciones: [] },
};

const CreateGramatica = ({ nodos, notify, archivos, refreshData, functionesChatbot, type }) => {
	const history = useHistory();
	return (
		<GramaticaForm
			gramatica={gramaticaDefault}
			type={type}
			guardaGramatica={save}
			nodos={nodos}
			archivos={archivos}
			functionesChatbot={functionesChatbot}
		/>
	);

	function save(gramatica) {
		delete gramatica._id;
		const data = { gramatica: gramatica };
		if (type === 'fuerte') {
			postGramaticaFuerte(data)
				.then(() => {
					notify('mGramatica actualizada');
					history.push('/gramaticas');
					setTimeout(refreshData, 100);
				})
				.catch((error) => {
					notify('eError al actualizar la gramática...');
				});
		} else {
			postGramaticaDebil(data).then(() => {
				notify('mGramatica actualizada');
				history.push('/gramaticas');
				setTimeout(refreshData, 100);
			});
		}
	}
};

export default CreateGramatica;
